// extracted by mini-css-extract-plugin
export default {"form":"AddProject_form__0chad"};